import styled from 'styled-components';
import {
  CaretRightEnabled,
  CaretRightDisabled,
  CaretLeftEnabled,
  CaretLeftDisabled,
  CloseLarge
} from '@carvana/purchase-icons';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(18, 41, 70, .9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Content = styled.div`
  position: relative;
  width: 80%;
  max-width: 500px;
`;

export const Image = styled.img`
  width: 100%;
  height: auto;
`;

export const CloseButton = styled(CloseLarge)`
  position: absolute;
  top: 30px;
  right: 50px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #FFFFFF;
`;

export const SubText = styled.div`
  color: white;
  text-align: center;
  margin: 40px 0 25px;
  font-weight: 450;
`;

export const ImageIndex = styled.div`
  color: white;
  font-weight: 450;
  font-size: 14px;
`;

export const Navigation = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;

export const NavigationButton = styled.button`
  background: ${props => props.active ? '#00AED9' : '#D6DCE2'};
  color: #FFFFFF;
  border: none;
  padding: 10px;
  cursor: pointer;
`;

export const NavigationButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: ${props => props.active ? '#00AED9' : '#D6DCE2'};
  border: none;
  cursor: pointer;
`;

export const NavigationPrevEnabled = styled(CaretLeftEnabled)`
  width: 18px;
  height: 18px;
`;

export const NavigationPrevDisabled = styled(CaretLeftDisabled)`
  width: 18px;
  height: 18px;
`;

export const NavigationNextEnabled = styled(CaretRightEnabled)`
  width: 18px;
  height: 18px;
  color: ${props => props.active ? '#FFFFFF' : '#B9C3CE'};
`;

export const NavigationNextDisabled = styled(CaretRightDisabled)`
  width: 18px;
  height: 18px;
  color: ${props => props.active ? '#FFFFFF' : '#B9C3CE'};
`;
